module.exports = __webpack_public_path__ + "static/media/scroll.e889f987.webp";